<div class="apc">
  <header class="apc-header">
    <div>
      <h1>API de tasas</h1>
      <p class="apc-sub">Consultá las tasas de tus productos y tus saldos desde tu propio sistema.</p>
    </div>
    <span class="apc-chip" *ngIf="estado" [ngClass]="estado.estado || 'NINGUNO'">{{ etiquetaEstado }}</span>
  </header>

  <div class="apc-cargando" *ngIf="cargando">Cargando…</div>
  <div class="apc-error" *ngIf="error">{{ error }}</div>

  <ng-container *ngIf="estado && !cargando">
    <!-- ==================================================== deshabilitado -->
    <div class="apc-bloqueo" *ngIf="deshabilitado">
      <h2>Tu acceso a la API está deshabilitado</h2>
      <p *ngIf="estado.motivo">Motivo: {{ estado.motivo }}</p>
      <p>Si creés que es un error, escribinos desde el chat de soporte.</p>
    </div>

    <!-- ==================================================== sin acceso -->
    <div class="apc-bloqueo" *ngIf="sinAcceso">
      <h2>Tu cuenta no tiene la API habilitada</h2>
      <p>El acceso lo habilita el equipo de Aguacate. Si ya lo pediste, revisá que tu cuenta siga aprobada y tu correo verificado.</p>
    </div>

    <!-- ==================================================== habilitado -->
    <ng-container *ngIf="habilitado">
      <div class="apc-auth">
        <span class="apc-auth-k">Autenticación</span>
        <span class="apc-auth-v">login firmado con Ed25519 y sesión de 15 minutos (o firma en cada petición)</span>
        <span class="apc-auth-sep" aria-hidden="true">·</span>
        <span class="apc-auth-k">Límites</span>
        <span class="apc-auth-v">{{ limite }} consultas/min · saldos {{ limiteSaldos }}/min · {{ maxIps }} IP por llave · llave válida {{ vigenciaDias }} días</span>
      </div>

      <nav class="apc-tabs">
        <button type="button" [class.on]="pestana === 'estado'" (click)="cambiarPestana('estado')">Mi acceso</button>
        <button type="button" [class.on]="pestana === 'uso'" (click)="cambiarPestana('uso')">Uso</button>
        <button type="button" [class.on]="pestana === 'documentacion'" (click)="cambiarPestana('documentacion')">Documentación</button>
        <button type="button" [class.on]="pestana === 'swagger'" (click)="cambiarPestana('swagger')">Swagger</button>
      </nav>

      <!-- -------------------------------------------------- mi acceso -->
      <ng-container *ngIf="pestana === 'estado'">
        <div class="apc-nums">
          <div class="apc-num">
            <span class="apc-num-label">Habilitado desde</span>
            <span class="apc-num-valor">{{ estado.invitadoEn ? (estado.invitadoEn | date: 'dd/MM/yyyy') : '—' }}</span>
            <span class="apc-num-sub" *ngIf="estado.activadoEn">Activado el {{ estado.activadoEn | date: 'dd/MM/yyyy HH:mm' }}</span>
            <span class="apc-num-sub" *ngIf="!estado.activadoEn">Todavía no activado</span>
          </div>
          <div class="apc-num">
            <span class="apc-num-label">Límite</span>
            <span class="apc-num-valor">{{ limite }}</span>
            <span class="apc-num-sub">consultas por minuto</span>
          </div>
          <div class="apc-num">
            <span class="apc-num-label">Llaves</span>
            <span class="apc-num-valor">{{ estado.maxLlaves ?? 1 }}</span>
            <span class="apc-num-sub">máximo de llaves activas</span>
          </div>
        </div>

        <section class="apc-bloque">
          <h3>Productos</h3>
          <p class="apc-ayuda">Todos los productos de Aguacate, incluidos los que se agreguen después.</p>
        </section>

        <!-- ============================================ llave de acceso -->
        <section class="apc-bloque">
          <h3>Llave de acceso</h3>

          <div class="apc-cargando" *ngIf="cargandoLlave">Consultando tu llave…</div>
          <div class="apc-error" *ngIf="errorLlave">{{ errorLlave }}</div>
          <div class="apc-ok" *ngIf="avisoLlave">{{ avisoLlave }}</div>
          <div class="apc-gracia" role="status" *ngIf="graciaVigente as g">
            La llave anterior sigue funcionando hasta <b>{{ g | date: 'HH:mm' }}</b>.
          </div>

          <ng-container *ngIf="!cargandoLlave">
            <!-- sin llave -->
            <div class="apc-sin-llave" *ngIf="!llave">
              <p>Todavía no tenés una llave. Se genera en tu navegador: Aguacate guarda sólo la clave pública y vos la privada.</p>
              <p class="apc-ayuda">Vas a necesitar el nombre de la llave y la IP pública del servidor que va a firmar las peticiones.</p>
              <button type="button" class="apc-btn" [disabled]="ocupado" (click)="abrirCrear()">Crear llave</button>
            </div>

            <!-- con llave -->
            <div class="apc-llave" *ngIf="llave">
              <div class="apc-llave-head">
                <div class="apc-llave-titulo">
                  <span class="apc-llave-nombre">{{ llave.nombre }}</span>
                  <code class="apc-kid">{{ llave.kid }}</code>
                </div>
                <span class="apc-chip" [ngClass]="llave.estado">{{ llave.estado === 'ACTIVA' ? 'Activa' : 'Revocada' }}</span>
              </div>

              <dl class="apc-llave-datos">
                <div>
                  <dt>IPs permitidas</dt>
                  <dd>
                    <code *ngFor="let ip of llave.ips" class="apc-ip">{{ ip }}</code>
                    <span *ngIf="!llave.ips?.length">—</span>
                  </dd>
                </div>
                <div>
                  <dt>Creada</dt>
                  <dd>{{ llave.creadaEn ? (llave.creadaEn | date: 'dd/MM/yyyy HH:mm') : '—' }}</dd>
                </div>
                <div>
                  <dt>Vence</dt>
                  <dd>
                    {{ llave.expiraEn ? (llave.expiraEn | date: 'dd/MM/yyyy') : '—' }}
                    <span class="apc-num-sub" [class.apc-por-vencer]="llavePorVencer" *ngIf="diasParaVencer !== null && diasParaVencer > 0"> · {{ diasParaVencer === 1 ? 'queda 1 día' : 'quedan ' + diasParaVencer + ' días' }}<ng-container *ngIf="llavePorVencer">: rota la llave pronto</ng-container></span>
                    <span class="apc-vencida" *ngIf="diasParaVencer !== null && diasParaVencer <= 0"> · vencida: rotá la llave</span>
                  </dd>
                </div>
                <div>
                  <dt>Último uso</dt>
                  <dd>
                    <ng-container *ngIf="llave.ultimoUsoEn; else sinUso">
                      {{ llave.ultimoUsoEn | date: 'dd/MM/yyyy HH:mm' }}
                      <span class="apc-num-sub" *ngIf="llave.ultimoUsoIp"> desde {{ llave.ultimoUsoIp }}</span>
                    </ng-container>
                    <ng-template #sinUso>Nunca</ng-template>
                  </dd>
                </div>
              </dl>

              <div class="apc-acciones">
                <button type="button" class="apc-btn secundario" [disabled]="ocupado" (click)="abrirEditarIps()">Editar IPs</button>
                <button type="button" class="apc-btn secundario" [disabled]="ocupado" (click)="confirmarRotar()">Rotar</button>
                <button type="button" class="apc-btn peligro" [disabled]="ocupado" (click)="revocar()">Revocar</button>
              </div>
              <p class="apc-ayuda">Rotar genera un par nuevo y revoca el actual. Si perdiste la clave privada, rotá.</p>
            </div>
          </ng-container>
        </section>
      </ng-container>

      <!-- -------------------------------------------------- uso -->
      <ng-container *ngIf="pestana === 'uso'">
        <div class="apc-uso-head">
          <p class="apc-doc-meta">Llamadas por día y ruta de los últimos 7 días, contadas por tu llave.</p>
          <button type="button" class="apc-btn secundario chico" [disabled]="cargandoUso" (click)="cargarUso()">Actualizar</button>
        </div>
        <div class="apc-cargando" *ngIf="cargandoUso">Cargando uso…</div>
        <div class="apc-error" *ngIf="errorUso">{{ errorUso }}</div>
        <ng-container *ngIf="!cargandoUso && !errorUso">
          <p class="apc-ayuda" *ngIf="!uso.length">Sin llamadas en los últimos 7 días.</p>
          <div class="apc-tabla-wrap" *ngIf="uso.length">
            <table class="apc-tabla">
              <thead>
                <tr>
                  <th>Día</th>
                  <th>Ruta</th>
                  <th class="num">OK</th>
                  <th class="num">401</th>
                  <th class="num">403</th>
                  <th class="num">429</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let f of uso">
                  <td>{{ f.dia | date: 'dd/MM/yyyy' }}</td>
                  <td><code>{{ f.ruta }}</code></td>
                  <td class="num">{{ f.ok | number }}</td>
                  <td class="num" [class.mal]="f.http401">{{ f.http401 | number }}</td>
                  <td class="num" [class.mal]="f.http403">{{ f.http403 | number }}</td>
                  <td class="num" [class.mal]="f.http429">{{ f.http429 | number }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="2">Total</td>
                  <td class="num">{{ totalUso('ok') | number }}</td>
                  <td class="num">{{ totalUso('http401') | number }}</td>
                  <td class="num">{{ totalUso('http403') | number }}</td>
                  <td class="num">{{ totalUso('http429') | number }}</td>
                </tr>
              </tfoot>
            </table>
          </div>
          <p class="apc-ayuda">401 = firma, fecha o nonce inválidos · 403 = IP no permitida · 429 = cupo por minuto superado.</p>
        </ng-container>
      </ng-container>

      <!-- -------------------------------------------------- swagger (fase 3) -->
      <ng-container *ngIf="pestana === 'swagger'">
        <div class="apc-uso-head">
          <p class="apc-doc-meta">Especificación OpenAPI de <code>/integraciones/v1</code>, vista con Swagger UI. Para probarla usá la colección Postman de la pestaña «Documentación».</p>
          <button type="button" class="apc-btn secundario chico" [disabled]="cargandoSwagger" (click)="cargarSwagger()">Actualizar</button>
        </div>
        <app-swagger-viewer [yaml]="openapiYaml" [cargando]="cargandoSwagger" [error]="errorSwagger"></app-swagger-viewer>
      </ng-container>

      <!-- -------------------------------------------------- documentación -->
      <ng-container *ngIf="pestana === 'documentacion'">
        <div class="apc-uso-head">
          <p class="apc-doc-meta">Guía de integración y especificación OpenAPI de <code>/integraciones/v1</code>.</p>
          <button type="button" class="apc-btn secundario chico" [disabled]="descargandoOpenapi" (click)="descargarOpenapi()">
            {{ descargandoOpenapi ? 'Descargando…' : 'Descargar OpenAPI' }}
          </button>
        </div>
        <div class="apc-error" *ngIf="errorOpenapi">{{ errorOpenapi }}</div>

        <!-- fase 3: descargas -->
        <section class="apc-bloque apc-descargas">
          <h3>Descargas</h3>
          <p class="apc-ayuda">La colección Postman firma el login con tu clave privada y guarda sola el token de sesión; {{ textoEntorno }}.</p>
          <div class="apc-acciones">
            <button type="button" class="apc-btn secundario chico" [disabled]="!!descargando" (click)="descargar('openapi')">{{ descargando === 'openapi' ? 'Descargando…' : 'OpenAPI (YAML)' }}</button>
            <button type="button" class="apc-btn secundario chico" [disabled]="!!descargando" (click)="descargar('postman')">{{ descargando === 'postman' ? 'Descargando…' : 'Colección Postman' }}</button>
            <button type="button" class="apc-btn secundario chico" [disabled]="!!descargando" (click)="descargar('entorno')">{{ descargando === 'entorno' ? 'Descargando…' : 'Entorno Postman' }}</button>
          </div>
          <div class="apc-error apc-error-descarga" *ngIf="errorDescarga">{{ errorDescarga }}</div>
        </section>
        <div class="apc-cargando" *ngIf="cargandoDoc">Cargando documentación…</div>
        <div class="apc-error" *ngIf="errorDoc">{{ errorDoc }}</div>
        <ng-container *ngIf="documentacion && !cargandoDoc">
          <p class="apc-doc-meta">
            Versión {{ documentacion.version }}
            <ng-container *ngIf="documentacion.actualizadoEn"> · actualizada el {{ documentacion.actualizadoEn | date: 'dd/MM/yyyy' }}</ng-container>
          </p>
          <article class="apc-doc" [innerHTML]="documentacion.html"></article>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</div>

<!-- ============================================================ asistente: crear / rotar -->
<div class="apc-velo" *ngIf="paso > 0" (click)="paso === 3 ? null : cerrarAsistente()">
  <div class="apc-dialogo" role="dialog" aria-modal="true" [attr.aria-label]="modo === 'rotar' ? 'Rotar llave' : 'Crear llave'" (click)="$event.stopPropagation()">
    <header class="apc-dialogo-head">
      <h2>{{ modo === 'rotar' ? 'Rotar llave' : 'Crear llave' }}</h2>
      <button type="button" class="apc-cerrar" aria-label="Cerrar" *ngIf="paso !== 3" [disabled]="ocupado" (click)="cerrarAsistente()">×</button>
    </header>

    <ol class="apc-pasos" aria-hidden="true">
      <li [class.on]="paso === 1" [class.hecho]="paso > 1">Nombre e IPs</li>
      <li [class.on]="paso === 2" [class.hecho]="paso > 2">Clave</li>
      <li [class.on]="paso === 3">Guardar</li>
    </ol>

    <!-- paso 1: nombre e IPs -->
    <ng-container *ngIf="paso === 1">
      <label class="apc-label" for="apc-nombre">Nombre de la llave</label>
      <input id="apc-nombre" class="apc-input" type="text" maxlength="120" placeholder="Servidor de cotizaciones" [(ngModel)]="formNombre" autocomplete="off" />
      <p class="apc-ayuda">Para reconocerla; por ejemplo el nombre del sistema que va a firmar.</p>

      <span class="apc-label">IPs permitidas (1 a {{ maxIps }})</span>
      <div class="apc-ips">
        <div class="apc-ip-fila" *ngFor="let ip of formIps; let i = index; trackBy: trackIndice">
          <input class="apc-input" type="text" [attr.aria-label]="'IP ' + (i + 1)" [placeholder]="i === 0 ? 'IP pública del servidor' : 'Segunda IP (opcional)'" [(ngModel)]="formIps[i]" autocomplete="off" spellcheck="false" />
          <button type="button" class="apc-btn secundario chico" *ngIf="ipActual && formIps[i] !== ipActual" (click)="usarIpActual(i)">Usar la mía</button>
        </div>
      </div>
      <p class="apc-ayuda" *ngIf="ipActual">Tu IP actual es <code>{{ ipActual }}</code>. Usala sólo si tu servidor sale a internet por esa misma IP.</p>
      <p class="apc-ayuda" *ngIf="!ipActual">Tiene que ser la IP pública desde la que tu servidor llama a la API (IPv4 o IPv6). No se aceptan IPs privadas.</p>

      <ul class="apc-errores" *ngIf="erroresForm.length">
        <li *ngFor="let e of erroresForm">{{ e }}</li>
      </ul>

      <footer class="apc-dialogo-pie">
        <button type="button" class="apc-btn secundario" (click)="cerrarAsistente()">Cancelar</button>
        <button type="button" class="apc-btn" (click)="continuarAPaso2()">Continuar</button>
      </footer>
    </ng-container>

    <!-- paso 2: clave -->
    <ng-container *ngIf="paso === 2">
      <div class="apc-resumen" *ngIf="modo === 'crear'">
        <span><b>{{ formNombre }}</b></span>
        <span><code *ngFor="let ip of ipsLimpias" class="apc-ip">{{ ip }}</code></span>
      </div>
      <div class="apc-resumen" *ngIf="modo === 'rotar' && llave">
        <span>Se revoca <code>{{ llave.kid }}</code> y se crea una nueva con el mismo nombre e IPs.</span>
      </div>

      <fieldset class="apc-gracia-opciones" *ngIf="modo === 'rotar'">
        <legend class="apc-label">Mantener la llave anterior activa durante</legend>
        <div class="apc-modo-clave">
          <label class="apc-radio" *ngFor="let op of opcionesGracia">
            <input type="radio" name="graciaMinutos" [value]="op.valor" [(ngModel)]="graciaMinutos" [disabled]="ocupado" />
            <span>{{ op.texto }}</span>
          </label>
        </div>
        <p class="apc-ayuda">
          Sirve para cambiar la clave en todos tus servidores sin corte.
          <b>Si rotas porque la clave se filtró, elige «No».</b>
        </p>
      </fieldset>

      <div class="apc-modo-clave">
        <label class="apc-radio">
          <input type="radio" name="modoClave" value="navegador" [(ngModel)]="modoClave" [disabled]="soportaEd25519 === false" />
          <span>Generar el par en este navegador <small>(recomendado)</small></span>
        </label>
        <label class="apc-radio">
          <input type="radio" name="modoClave" value="manual" [(ngModel)]="modoClave" (change)="alElegirManual()" />
          <span>Ya tengo un par: pego la clave pública</span>
        </label>
      </div>

      <p class="apc-ayuda" *ngIf="modoClave === 'navegador'">
        Se genera un par Ed25519 con WebCrypto. La clave pública se registra en Aguacate; la privada se te muestra una sola vez en el paso siguiente y nunca sale de tu navegador.
      </p>

      <ng-container *ngIf="modoClave === 'manual'">
        <p class="apc-ayuda">Generá el par en tu servidor y pegá acá la pública (hex de 64 caracteres o PEM):</p>
        <pre class="apc-pre chico">openssl genpkey -algorithm ed25519 -out privada.pem
openssl pkey -in privada.pem -pubout -out publica.pem
cat publica.pem</pre>
        <label class="apc-label" for="apc-publica">Clave pública</label>
        <textarea id="apc-publica" class="apc-input apc-textarea" rows="4" [(ngModel)]="clavePublicaManual" spellcheck="false" placeholder="-----BEGIN PUBLIC KEY-----&#10;…&#10;-----END PUBLIC KEY-----"></textarea>

        <!-- prueba de posesión -->
        <div class="apc-prueba">
          <span class="apc-label">Prueba de que tienes la clave privada</span>
          <p class="apc-ayuda">Firma este desafío con la clave privada de la pública que pegaste y pega la firma abajo. Vale una sola vez y por poco tiempo.</p>
          <div class="apc-cargando" *ngIf="cargandoDesafio">Pidiendo el desafío…</div>
          <div class="apc-error" *ngIf="errorDesafio">{{ errorDesafio }}</div>
          <ng-container *ngIf="desafio && !cargandoDesafio">
            <pre class="apc-pre chico">{{ desafio.desafio }}</pre>
            <p class="apc-num-sub" [class.apc-vencida]="desafioVencido">
              {{ desafioVencido ? 'Venció: pide otro.' : 'Vence ' + (desafio.expiraEn | date: 'HH:mm:ss') }}
            </p>
            <span class="apc-label">Comando para firmarlo (OpenSSL 3)</span>
            <pre class="apc-pre chico">{{ comandoFirma }}</pre>
          </ng-container>
          <div class="apc-acciones">
            <button type="button" class="apc-btn secundario chico" *ngIf="desafio && !desafioVencido" (click)="copiarDesafio()">{{ desafioCopiado ? 'Copiado' : 'Copia el desafío' }}</button>
            <button type="button" class="apc-btn secundario chico" *ngIf="desafio && !desafioVencido" (click)="copiarComando()">{{ comandoCopiado ? 'Copiado' : 'Copia el comando' }}</button>
            <button type="button" class="apc-btn secundario chico" [disabled]="cargandoDesafio" *ngIf="!desafio || desafioVencido || errorDesafio" (click)="pedirDesafio()">Pedir otro</button>
          </div>
          <label class="apc-label" for="apc-firma">Firma (base64url)</label>
          <textarea id="apc-firma" class="apc-input apc-textarea" rows="2" [(ngModel)]="firmaManual" spellcheck="false" autocomplete="off" placeholder="Pega aquí la salida del comando"></textarea>
        </div>
      </ng-container>

      <div class="apc-error" *ngIf="errorCrear">
        {{ errorCrear }}
        <ul class="apc-causas" *ngIf="causasCrear.length">
          <li *ngFor="let c of causasCrear">{{ c }}</li>
        </ul>
      </div>

      <footer class="apc-dialogo-pie">
        <button type="button" class="apc-btn secundario" [disabled]="ocupado" (click)="volverOCancelar()">{{ modo === 'crear' ? 'Volver' : 'Cancelar' }}</button>
        <button type="button" class="apc-btn" [disabled]="ocupado || (modoClave === 'manual' && (!clavePublicaManual.trim() || !firmaManual.trim() || desafioVencido))" (click)="generarYEnviar()">
          {{ ocupado ? 'Registrando…' : modo === 'rotar' ? 'Rotar llave' : 'Crear llave' }}
        </button>
      </footer>
    </ng-container>

    <!-- paso 3: una sola vez -->
    <ng-container *ngIf="paso === 3">
      <div class="apc-gracia" role="status" *ngIf="modo === 'rotar' && graciaVigente as g">
        La llave anterior sigue funcionando hasta <b>{{ g | date: 'HH:mm' }}</b>.
      </div>
      <div class="apc-aviso-fuerte">
        <b>Aguacate no guarda esta clave.</b> Guardala ahora en tu servidor: no se vuelve a mostrar. Si la perdés, rotá la llave.
      </div>

      <span class="apc-label">Identificador de la llave (kid) · va en la cabecera <code>X-Aguacate-Llave</code></span>
      <pre class="apc-pre">{{ llave?.kid || revelada?.kid }}</pre>

      <ng-container *ngIf="revelada">
        <span class="apc-label">Clave privada Ed25519 (32 bytes en hex)</span>
        <pre class="apc-pre apc-privada">{{ revelada.privadaHex }}</pre>
        <div class="apc-acciones">
          <button type="button" class="apc-btn secundario" (click)="copiarPrivada()">{{ copiado ? 'Copiada' : 'Copiar' }}</button>
          <button type="button" class="apc-btn secundario" (click)="descargarPem()">Descargar PEM</button>
        </div>
        <p class="apc-ayuda">El PEM es la misma clave en formato PKCS#8, lista para <code>openssl</code> o la librería de tu lenguaje.</p>
      </ng-container>

      <p class="apc-ayuda" *ngIf="!revelada">Registramos la clave pública que pegaste. La privada la tenés vos en tu servidor.</p>

      <footer class="apc-dialogo-pie">
        <button type="button" class="apc-btn" (click)="terminarRevelado()">Ya la guardé</button>
      </footer>
    </ng-container>
  </div>
</div>

<!-- ============================================================ diálogo: editar IPs -->
<div class="apc-velo" *ngIf="editandoIps" (click)="cerrarEditarIps()">
  <div class="apc-dialogo" role="dialog" aria-modal="true" aria-label="Editar IPs de la llave" (click)="$event.stopPropagation()">
    <header class="apc-dialogo-head">
      <h2>Editar IPs</h2>
      <button type="button" class="apc-cerrar" aria-label="Cerrar" [disabled]="ocupado" (click)="cerrarEditarIps()">×</button>
    </header>

    <span class="apc-label">IPs permitidas (1 a {{ maxIps }})</span>
    <div class="apc-ips">
      <div class="apc-ip-fila" *ngFor="let ip of formIpsEdicion; let i = index; trackBy: trackIndice">
        <input class="apc-input" type="text" [attr.aria-label]="'IP ' + (i + 1)" [placeholder]="i === 0 ? 'IP pública del servidor' : 'Segunda IP (opcional)'" [(ngModel)]="formIpsEdicion[i]" autocomplete="off" spellcheck="false" />
        <button type="button" class="apc-btn secundario chico" *ngIf="ipActual && formIpsEdicion[i] !== ipActual" (click)="usarIpActualEnEdicion(i)">Usar la mía</button>
      </div>
    </div>
    <p class="apc-ayuda" *ngIf="ipActual">Tu IP actual es <code>{{ ipActual }}</code>.</p>
    <p class="apc-ayuda">El cambio rige en menos de un minuto. Las peticiones desde otra IP reciben 403.</p>

    <ul class="apc-errores" *ngIf="erroresIps.length">
      <li *ngFor="let e of erroresIps">{{ e }}</li>
    </ul>
    <div class="apc-error" *ngIf="errorIps">{{ errorIps }}</div>

    <footer class="apc-dialogo-pie">
      <button type="button" class="apc-btn secundario" [disabled]="ocupado" (click)="cerrarEditarIps()">Cancelar</button>
      <button type="button" class="apc-btn" [disabled]="ocupado" (click)="guardarIps()">{{ ocupado ? 'Guardando…' : 'Guardar' }}</button>
    </footer>
  </div>
</div>
